module.exports = __webpack_public_path__ + "media/images/shared/icon-rules-seminar-c6f824569718eb37e2cfe2b02c0cd475.png";